
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/category/[categorySlug]",
      function () {
        return require("private-next-pages/blogs/category/[categorySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/category/[categorySlug]"])
      });
    }
  